/* global gsap */
import { useRef, useState, useEffect } from 'react';
import FontFaceObserver from 'fontfaceobserver';
import useInview from 'effects/inview';

const fontObserver = new FontFaceObserver('ABCGintoNordCondensed Bold', {
  weight: 400,
});

export default <T extends Element = HTMLElement>() => {
  const [ref, inview] = useInview<T>({ threshold: 0.5 });
  const animation = useRef<GsapTimeline | null>(null);
  const [font, setFont] = useState(false);
  const [image, setImage] = useState(false);

  function animate() {
    if (animation.current) {
      animation.current.play();
    }
  }

  useEffect(() => {
    const img = ref.current!.querySelector('.thumb');
    const category = ref.current!.querySelector('.category');
    const heading = ref.current!.querySelectorAll('h2');
    const more = ref.current!.querySelector('.more');

    animation.current = gsap.timeline({
      delay: 0.2,
      paused: true,
    });

    animation.current
      .fromTo(
        img,
        1,
        { opacity: 0, y: 5 },
        { opacity: 1, y: 0, clearProps: true }
      )
      .fromTo(
        [category, heading, more],
        1,
        { opacity: 0, y: 10 },
        {
          opacity: 1,
          y: 0,
          clearProps: true,
          stagger: 0.2,
          ease: 'power1.inOut',
        },
        '-=1'
      );

    return () => {
      animation.current!.pause();
      animation.current!.kill();
      animation.current = null;
    };
  }, []);

  useEffect(() => {
    let cancel = false;

    fontObserver.load(null, 3000).then(() => {
      if (!cancel) {
        setFont(true);
      }
    });

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    const image = ref.current!.querySelector('img')!;

    function onLoad() {
      setImage(true);
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onLoad);

    if (image.complete && image.naturalHeight !== 0) {
      setImage(true);
    }

    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onLoad);
    };
  }, []);

  useEffect(() => {
    if (font && image && inview) {
      animate();
    }
  }, [font, image, inview]);
  return ref;
};
